import React from 'react';
import $ from 'jquery';
import OwlCarousel from 'react-owl-carousel';  
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';

class Carousel extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            showContent: false,
            itemsArray: [],
            options: {
                loop:true,
                dots: true,
                dotsEach: 1,
                margin:10,
                nav: true,
                lazyLoad: true,
                navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
                responsive:{
                    0: {
                        items: 1,
                        stagePadding: 0
                    },
                    590: {
                        items: 1,
                        stagePadding: 140
                    },
                    641: {
                        items: 2,
                        stagePadding: 50
                    },
                    991: {
                        items: 2,
                        stagePadding: 160
                    }
                }
            }
        };
    }
    componentDidMount(){
        this.props.carouselData &&
        this.props.carouselData.forEach(carouselContent => {
            if(!Array.isArray(carouselContent.content)){
                this.setState({
                    [carouselContent.acf_fc_layout]: carouselContent.content
                })
            }
            else{
                this.setState({
                    itemsArray: carouselContent
                })
            }
        })
        this.setState({
            showContent: true
        })
    }
    ariaLabelAdd = () => {
        $('.owl-carousel').each(function() {
            $(this).find('.owl-dot').each(function(index) {
                $(this).attr('aria-label', index + 1 +'-slide');
                $(this).attr('name', 'read next testimonial');
                $(this).attr('type', 'submit');
                $(this).attr('value', 'read next testimonial');
            });
            $(this).find('button.owl-prev').attr('aria-label', 'previous-slide');
            $(this).find('button.owl-next').attr('aria-label', 'next-slide');
        });
    }
    render(){
        return(
            <React.Fragment>
                {this.state.showContent?
                <div className="container-fluid carousel-img">
                    <div className="row">
                        <div className="col carousel-heading">
                            <div dangerouslySetInnerHTML={{ __html: this.state.hero_text_block}}/>
                        </div>
                    </div>
                    <div className="row">
                        <OwlCarousel  
                            className="owl-theme" {...this.state.options} onInitialized={this.ariaLabelAdd}> 
                                {this.state.itemsArray.content && this.state.itemsArray.content.map((reviewBlock,i)=>(
                                    <div className="item" key={i}
                                        dangerouslySetInnerHTML={{ __html: reviewBlock.testimonial}}>
                                    </div>
                                ))}
                        </OwlCarousel> 
                    </div>
                </div>: null
            }
        </React.Fragment>
        )
    }
}
export default Carousel